import * as Sentry from '@sentry/vue';
export default (function (_ref) {
  var router = _ref.router,
    Vue = _ref.Vue;
  if (process.env.NODE_ENV === 'production') {
    Sentry.init({
      Vue: Vue,
      dsn: 'https://9dd1c3b8a083485aa5c07f08a77c2f7c@o78498.ingest.sentry.io/4505740882804736',
      integrations: [new Sentry.BrowserTracing({
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ['localhost', 'portal.ozeit.com.au'],
        routingInstrumentation: Sentry.vueRouterInstrumentation(router)
      })],
      // Performance Monitoring
      tracesSampleRate: 0 // Capture 100% of the transactions, reduce in production!
    });
  }
});